(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lina-surface-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lina-surface-finder')) {
    customElements.define('lina-surface-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        const choices = [...this.querySelectorAll('[data-lina-choice]')];
        const panels = [...this.querySelectorAll('[data-lina-panel]')];
        const select = (id, focus = false) => {
          if (!choices.some(choice => choice.dataset.linaChoice === id)) return;
          choices.forEach(choice => {
            const active = choice.dataset.linaChoice === id;
            choice.setAttribute('aria-pressed', String(active));
            if (active && focus) choice.focus();
          });
          panels.forEach(panel => panel.hidden = panel.dataset.linaPanel !== id);
        };
        choices.forEach((choice, index) => {
          choice.hidden = false;
          choice.addEventListener('click', () => select(choice.dataset.linaChoice), { signal });
          choice.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % choices.length;
            if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + choices.length) % choices.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = choices.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            select(choices[next].dataset.linaChoice, true);
          }, { signal });
        });
        document.addEventListener('shopify:block:select', event => {
          if (event.detail?.blockId) select(event.detail.blockId);
        }, { signal });
        if (choices.length) {
          this.setAttribute('data-enhanced', '');
          select(choices[0].dataset.linaChoice);
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
